/*
 * Marke Week: cuentas atrás, el paquete que se abre tirando del cordel, el aviso en el calendario y los regalos
 * de los días pasados. Lo que se enseña lo decide el servidor; si la página viene de la caché con un estado viejo
 * (por ejemplo, de antes de las 10:00), se vuelve a pedir la sección.
 */
(() => {
  if (customElements.get('marke-week')) return;

  const DIA = 86400000;
  const MAX_REFRESCOS = 4;
  let refrescos = 0;

  const leer = (clave) => {
    try {
      return localStorage.getItem(clave);
    } catch (e) {
      return null;
    }
  };
  const guardar = (clave, valor) => {
    try {
      localStorage.setItem(clave, valor);
    } catch (e) {}
  };
  const dos = (n) => String(n).padStart(2, '0');
  const formato = (ms) => {
    const t = Math.max(0, Math.floor(ms / 1000));
    const d = Math.floor(t / 86400);
    const reloj = `${dos(Math.floor((t % 86400) / 3600))}:${dos(Math.floor((t % 3600) / 60))}:${dos(t % 60)}`;
    return d ? `${d} ${d === 1 ? 'día' : 'días'} y ${reloj}` : reloj;
  };
  const sinMovimiento = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class MarkeWeek extends HTMLElement {
    connectedCallback() {
      this.servidor = Number(this.dataset.ahora) * 1000;
      this.prueba = this.dataset.prueba === 'true';
      this.salto = this.prueba ? this.servidor - Date.now() : 0;
      this.limites = JSON.parse(this.dataset.limites || '[]').map((s) => s * 1000);
      this.ultimo = this.ahora();
      if (!this.prueba && this.limites.some((l) => l > this.servidor && l <= Date.now())) this.refrescar();

      this.cuentas = [...this.querySelectorAll('[data-cuenta]')];
      this.tic();
      this.reloj = setInterval(() => this.tic(), 1000);

      this.prepararPaquete();
      this.prepararSemana();
      this.prepararPopup();
      this.querySelectorAll('[data-avisame]').forEach((boton) => boton.addEventListener('click', () => this.avisame(boton)));
    }

    disconnectedCallback() {
      clearInterval(this.reloj);
    }

    ahora() {
      return Date.now() + this.salto;
    }

    tic() {
      const ahora = this.ahora();
      for (const el of this.cuentas) el.textContent = formato(Number(el.dataset.cuenta) * 1000 - ahora);
      // Al cruzar una hora clave (las 10:00, la medianoche) se pide la sección otra vez, con un pequeño margen
      // por si el reloj del cliente va adelantado.
      if (!this.prueba && this.limites.some((l) => l > this.ultimo && l <= ahora)) setTimeout(() => this.refrescar(), 2000);
      this.ultimo = ahora;
    }

    async refrescar() {
      if (this.refrescando || refrescos >= MAX_REFRESCOS) return;
      this.refrescando = true;
      refrescos++;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.section);
        url.searchParams.set('mw', Date.now());
        const respuesta = await fetch(url, { cache: 'no-store' });
        if (respuesta.ok) {
          const nuevo = new DOMParser().parseFromString(await respuesta.text(), 'text/html').querySelector('marke-week');
          // Sin <marke-week> es que ya no toca enseñarla (la banda, acabada la semana)
          if (nuevo) this.replaceWith(nuevo);
          else this.remove();
          return;
        }
      } catch (e) {}
      this.refrescando = false;
    }

    prepararPaquete() {
      const paquete = this.querySelector('.mw-paquete[data-abrible]');
      if (!paquete) return;
      this.paquete = paquete;
      // En pruebas no se recuerda, para poder repetir la apertura
      this.clave = this.prueba ? null : `mw-abierto-${paquete.dataset.fecha}`;
      if (this.clave && leer(this.clave)) {
        this.classList.add('is-abierto', 'sin-entrada');
        return;
      }

      const tirador = paquete.querySelector('.mw-paquete__tirador');
      let inicio = null;
      let tiron = 0;
      let arrastrado = false;
      const poner = (valor) => {
        tiron = valor;
        paquete.style.setProperty('--tiron', valor.toFixed(3));
      };
      const soltar = (abrir) => {
        if (inicio === null) return;
        inicio = null;
        paquete.classList.remove('is-tirando');
        if (abrir || tiron > 0.55) this.abrir();
        else poner(0);
      };

      tirador.addEventListener('pointerdown', (e) => {
        inicio = e.clientY;
        arrastrado = false;
        tirador.setPointerCapture(e.pointerId);
        paquete.classList.add('is-tirando');
      });
      tirador.addEventListener('pointermove', (e) => {
        if (inicio === null) return;
        const recorrido = e.clientY - inicio;
        if (Math.abs(recorrido) > 6) arrastrado = true;
        poner(Math.min(1, Math.max(0, recorrido / 120)));
        if (tiron >= 1) soltar(true);
      });
      tirador.addEventListener('pointerup', () => soltar(false));
      tirador.addEventListener('pointercancel', () => soltar(false));
      tirador.addEventListener('lostpointercapture', () => soltar(false));

      // Un clic (o Intro) también lo abre: da un tirón solo y se abre.
      paquete.addEventListener('click', () => {
        if (arrastrado) {
          arrastrado = false;
          return;
        }
        if (sinMovimiento()) return this.abrir();
        paquete.classList.add('is-tiron-auto');
        setTimeout(() => this.abrir(), 380);
      });
    }

    abrir() {
      if (this.abriendo) return;
      this.abriendo = true;
      if (this.clave) guardar(this.clave, '1');
      const regalo = this.querySelector('.mw-regalo');
      try {
        window.Shopify?.analytics?.publish?.('marke_week_abrir', { fecha: this.paquete.dataset.fecha });
      } catch (e) {}

      const fin = () => {
        this.classList.remove('is-abriendo');
        this.classList.add('is-abierto');
        regalo?.focus({ preventScroll: true });
      };
      if (sinMovimiento()) return fin();
      this.classList.add('is-abriendo');
      setTimeout(() => this.chispas(), 430);
      setTimeout(fin, 1000);
    }

    chispas() {
      const escenario = this.querySelector('.mw__escenario');
      if (!escenario || !this.paquete) return;
      const caja = escenario.getBoundingClientRect();
      const origen = this.paquete.getBoundingClientRect();
      const lienzo = document.createElement('canvas');
      lienzo.className = 'mw__chispas';
      lienzo.setAttribute('aria-hidden', 'true');
      const ppp = Math.min(2, window.devicePixelRatio || 1);
      lienzo.width = caja.width * ppp;
      lienzo.height = caja.height * ppp;
      escenario.appendChild(lienzo);
      const ctx = lienzo.getContext('2d');
      ctx.scale(ppp, ppp);

      const cx = origen.left - caja.left + origen.width / 2;
      const cy = origen.top - caja.top + origen.height / 2;
      const colores = ['#f2c46b', '#ffe3a3', '#e0a94a', '#c69b69', '#fbf6ec'];
      const piezas = Array.from({ length: 80 }, () => {
        const angulo = Math.random() * Math.PI * 2;
        const velocidad = 3 + Math.random() * 8;
        return {
          x: cx,
          y: cy,
          vx: Math.cos(angulo) * velocidad,
          vy: Math.sin(angulo) * velocidad - 4,
          r: 2 + Math.random() * 4,
          giro: Math.random() * 6,
          color: colores[Math.floor(Math.random() * colores.length)],
          papel: Math.random() < 0.4,
        };
      });
      const t0 = performance.now();
      const paso = (t) => {
        const p = (t - t0) / 1500;
        ctx.clearRect(0, 0, caja.width, caja.height);
        if (p >= 1) return lienzo.remove();
        ctx.globalAlpha = 1 - p * p;
        for (const k of piezas) {
          k.vy += 0.24;
          k.vx *= 0.985;
          k.x += k.vx;
          k.y += k.vy;
          k.giro += 0.16;
          ctx.fillStyle = k.color;
          if (k.papel) {
            ctx.save();
            ctx.translate(k.x, k.y);
            ctx.rotate(k.giro);
            ctx.fillRect(-k.r, -k.r * 0.6, k.r * 2, k.r * 1.2);
            ctx.restore();
          } else {
            ctx.beginPath();
            ctx.arc(k.x, k.y, k.r * 0.6, 0, Math.PI * 2);
            ctx.fill();
          }
        }
        requestAnimationFrame(paso);
      };
      requestAnimationFrame(paso);
    }

    prepararSemana() {
      const panel = this.querySelector('[data-fue-panel]');
      if (!panel) return;
      const botones = [...this.querySelectorAll('.mw-dia__boton[data-dia]')];
      botones.forEach((boton) =>
        boton.addEventListener('click', () => {
          const abierto = boton.getAttribute('aria-expanded') === 'true';
          botones.forEach((b) => b.setAttribute('aria-expanded', 'false'));
          if (abierto) {
            panel.hidden = true;
            return;
          }
          const plantilla = this.querySelector(`template[data-fue-dia="${boton.dataset.dia}"]`);
          panel.replaceChildren(plantilla.content.cloneNode(true));
          panel.hidden = false;
          boton.setAttribute('aria-expanded', 'true');
        })
      );
    }

    // Popup: una vez al día, nunca en la página de la Marke Week ni encima de otra ventana (la newsletter sale a los 5 s)
    prepararPopup() {
      const dialogo = this.querySelector('dialog.mw--popup');
      if (!dialogo || typeof dialogo.showModal !== 'function') return;
      if (window.location.pathname === new URL(this.dataset.url || '/', window.location.origin).pathname) return;
      const hoy = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Madrid' }).format(new Date(this.ahora()));
      const clave = `mw-popup-${hoy}`;
      if (!this.prueba && leer(clave)) return;

      const cerrar = () => dialogo.close();
      dialogo.addEventListener('close', () => {
        if (!this.prueba) guardar(clave, '1');
      });
      dialogo.querySelectorAll('[data-cerrar]').forEach((b) => b.addEventListener('click', cerrar));
      // Clic fuera de la caja (en el fondo)
      dialogo.addEventListener('click', (e) => {
        if (e.target === dialogo) cerrar();
      });
      const abrir = (intentos = 0) => {
        if (!this.isConnected || dialogo.open) return;
        // Ni encima de la newsletter ni de la ventana de personalizar (modal de Bootstrap)
        const otro = document.querySelector('newsletter-popup[open], dialog[open], .modal.show');
        if (otro && intentos < 30) return setTimeout(() => abrir(intentos + 1), 2000);
        dialogo.showModal();
      };
      setTimeout(abrir, this.prueba ? 1500 : 7000);
    }

    // Un .ics con un aviso a la hora de apertura de cada día que falta.
    avisame(boton) {
      const hora = Number(this.dataset.hora);
      const inicio = Number(this.dataset.inicio) * 1000;
      const url = new URL(this.dataset.url || window.location.pathname, window.location.origin).href;
      const utc = (ms) => new Date(ms).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
      const sello = utc(Date.now());
      const eventos = [];
      for (let i = 0; i < 7; i++) {
        const abre = inicio + i * DIA + hora * 3600000;
        if (abre <= this.ahora()) continue;
        eventos.push(
          [
            'BEGIN:VEVENT',
            `UID:marke-week-${abre}@markegifts.com`,
            `DTSTAMP:${sello}`,
            `DTSTART:${utc(abre)}`,
            `DTEND:${utc(abre + 15 * 60000)}`,
            'SUMMARY:Marke Week: se abre el regalo del día',
            `DESCRIPTION:A las ${hora}:00 se abre un regalo nuevo en Markegifts\\, con un precio que solo dura ese día. ${url}`,
            `URL:${url}`,
            'BEGIN:VALARM',
            'TRIGGER:PT0M',
            'ACTION:DISPLAY',
            'DESCRIPTION:Marke Week',
            'END:VALARM',
            'END:VEVENT',
          ].join('\r\n')
        );
      }
      if (!eventos.length) return;
      const ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Markegifts//Marke Week//ES', 'CALSCALE:GREGORIAN', ...eventos, 'END:VCALENDAR'].join('\r\n');
      const enlace = document.createElement('a');
      enlace.href = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
      enlace.download = 'marke-week.ics';
      document.body.appendChild(enlace);
      enlace.click();
      enlace.remove();
      setTimeout(() => URL.revokeObjectURL(enlace.href), 4000);
      if (boton) {
        const texto = boton.textContent;
        boton.textContent = 'Listo: abre el archivo para añadirlo';
        setTimeout(() => (boton.textContent = texto), 4000);
      }
    }
  }

  customElements.define('marke-week', MarkeWeek);
})();
